export default {
	title: "Suporte",
	newTicket: "Novo Chamado",
	ticketDetail: "Detalhes do Chamado",
	subject: "Assunto",
	description: "Descrição",
	category: "Categoria",
	noTickets: "Nenhum chamado encontrado",
	noTicketsDescription: "Você ainda não abriu nenhum chamado de suporte",
	comments: "Comentários",
	replyPlaceholder: "Digite sua resposta...",
	send: "Enviar",
	createdAt: "Aberto em",
	updatedAt: "Atualizado em",
	backToList: "Voltar aos chamados",
	totalTickets: "Total",
	openTickets: "Abertos",
	categories: {
		BUG: "Bug",
		FEATURE: "Sugestão",
		QUESTION: "Dúvida",
	},
	status: {
		OPEN: "Aberto",
		IN_PROGRESS: "Em Andamento",
		RESOLVED: "Resolvido",
		CLOSED: "Fechado",
	},
	attachImage: "Anexar imagem",
	messages: {
		ticketCreated: "Chamado criado com sucesso",
		commentAdded: "Resposta enviada com sucesso",
		errorCreating: "Erro ao criar chamado",
		errorLoading: "Erro ao carregar chamados",
		errorAddingComment: "Erro ao enviar resposta",
		imageTooLarge: "Imagem muito grande. Tamanho máximo: 5MB",
	},
	table: {
		headers: {
			subject: "Assunto",
			category: "Categoria",
			status: "Status",
			date: "Data",
			comments: "Respostas",
		},
	},
};
